import { call, put, select, takeEvery } from 'redux-saga/effects'

import { PaymentActions } from 'features'
import { campaignPublicSelector, getLoyaltyBalanceSaga } from 'primsell-shared-layer/features'
import { CodeTypeE, IPublicCampaign } from 'primsell-shared-layer/types'
import { PaymentInfoTypeE } from './payment.types'

export function* checkBalanceAfterConnectSaga(
  action: ReturnType<typeof PaymentActions.checkBalanceAfterConnect>
): Generator {
  try {
    const balance = (yield call(getLoyaltyBalanceSaga, {
      payload: action.payload,
      type: 'wallet/getWalletLoyaltyBalanceRequest',
    })) as bigint

    const publicCampaignDetails = (yield select(campaignPublicSelector)) as IPublicCampaign

    if (
      publicCampaignDetails.codeType === CodeTypeE.LOYALTY &&
      publicCampaignDetails.maxAmountPerPurchase &&
      Number(balance.toString()) >= publicCampaignDetails.maxAmountPerPurchase
    ) {
      yield put(PaymentActions.setPaymentInfo({ info: PaymentInfoTypeE.LOYALTY_ALREADY_PURCHASED }))
    }
  } catch (error) {
    yield put(PaymentActions.clearPaymentInfo())
  }
}

function* paymentSagas(): Generator {
  yield takeEvery(PaymentActions.checkBalanceAfterConnect, checkBalanceAfterConnectSaga)
}

export { paymentSagas }
